import {LIST_CARDS, REMOVE_CARD} from "../actions/Card"

const CardReducer = (state = {linkedCards: [], closeBannerCount: 0}, action) => {
  const {cards, card} = action

  switch (action.type) {
    case LIST_CARDS:
      return list(state, cards)
    case REMOVE_CARD:
      return remove(state, card)
    default:
      return state
  }
}

export default CardReducer

const list = (state, cards) => {
  return {
    ...state,
    linkedCards: cards || state.linkedCards
  }
}

const remove = (state, card) => ({
  ...state,
  linkedCards: state.linkedCards.filter((test) => test.uuid !== card.uuid)
})
